export default "/_next/static/images/at-logo-421e560a8a85279b2ae6a3f4698e91ab.png";